import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const Settings = Loadable(lazy(() => import("./settings.jsx")));

const settingsRoutes = [
    { path: "/setting", element: <Settings/> },
];

export default settingsRoutes;